export default __webpack_public_path__ + "static/media/flip-flops.da39ebfe.webp";